import type { oz } from '@weft/utils';
import { GenerateMeasurementsDataSchema } from './generate-measurements-data-schema';

export const GenerateMeasurementsRequestSchema = GenerateMeasurementsDataSchema.openapi('GenerateMeasurementsRequest');

export type GenerateMeasurementsRequestPayload = oz.infer<typeof GenerateMeasurementsRequestSchema>;